var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-field',[_c('label',[_vm._t("default")],2),_c('md-input',{model:{value:(_vm.pw),callback:function ($$v) {_vm.pw=$$v},expression:"pw"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }